<template>
  <svg :class="svgClassName" aria-hidden="true" :width="size" :height="size" v-bind="attrs">
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script>
import { defineComponent, computed, useAttrs } from 'vue';

export default defineComponent({
  name: 'SvgIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: 'icon',
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
  setup(props) {
    const symbolId = computed(() => `#${props.prefix}-${props.name}`);
    const svgClassName = computed(() => {
      const baseClass = 'svg-icon text-slate-600 dark:text-slate-300';
      if (props.className)
        return `${baseClass} ${props.className}`;
      return baseClass;
    });
    const attrs = useAttrs();
    return { symbolId, svgClassName, attrs };
  },
})
</script>

<style scoped>
.svg-icon {
  fill: currentColor;
}
</style>
